import React, { useRef, useState } from "react";
import {
  UserOutlined,
  DownOutlined,
  LogoutOutlined,
  InstagramOutlined,
  FacebookOutlined,
  // LinkedinFilled,
  YoutubeFilled,
  // MobileTwoTone
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router-dom";
import {
  Avatar,
  Layout,
  Divider,
  // Menu,
  Popover,
  // theme,
  Typography,
  Image,
  Modal,
  Button,
  Input,
  Form,
  // Badge,
} from "antd";
import { Link } from "react-router-dom";
// import Logo from "../../assets/images/Logo.jpg";
import Logo1 from "../../assets/images/logo-dark.png";
import "./index.css";
// import { BsTwitterX } from "react-icons/bs";
import { isEmpty } from "lodash";
import { FaKey } from "react-icons/fa6";
import SimpleReactValidator from "simple-react-validator";
import axiosInstance from "../../helpers";
import { toast, ToastContainer } from "react-toastify";

const { Header, Content, Footer } = Layout;

const items = [
  // {
  //   key: "redeem",
  //   label: (
  //     <Link
  //       to={{
  //         pathname: "/redeem",
  //       }}
  //     >
  //       Redeem
  //     </Link>
  //   ),
  //   // icon: <DashboardFilled />,
  // },
  // {
  //   key: "referral",
  //   label: (
  //     <Link
  //       to={{
  //         pathname: "/referral",
  //       }}
  //     >
  //       Referral
  //     </Link>
  //   ),
  //   // icon: <DashboardFilled />,
  // },
  {
    key: "myAccount",
    label: (
      <Link
        to={{
          pathname: "/my-account",
        }}
      >
        My Account
      </Link>
    ),
    // icon: <DashboardFilled />,
  },
  {
    key: "aboutProgram",
    label: (
      <Link
        to={{
          pathname: "/about-program",
        }}
      >
        About The Program
      </Link>
    ),
    // icon: <DashboardFilled />,
  },
  {
    key: "faq",
    label: (
      <Link
        to={{
          pathname: "/faq",
        }}
      >
        FAQ
      </Link>
    ),
    // icon: <DashboardFilled />,
  },
];

const LayoutMain = (props) => {
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  const rewards = localStorage.getItem("reward");

  const reward = rewards && JSON.parse(rewards);
  const [modal, setModal] = useState(false);

  console.log(reward, "reward");

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  const [userData, setUserData] = useState({
    phoneNumber: "",
    currentKey: "",
    newKey: "",
    confirmKey: "",
  });

  // const onClickHandle = (e) => {
  //   const { name, value } = e.target;

  //   const validationRules = {
  //     phoneNumber: /^[0-9]*$/,
  //     currentKey: /^[0-9]*$/,
  //     newKey: /^[0-9]*$/,
  //     confirmKey: /^[0-9]*$/,
  //   };

  //   if (validationRules[name]) {
  //     // Only update the state if the value is empty or passes the regex test
  //     if (validationRules[name].test(value) || value === "") {
  //       setUserData({
  //         ...userData,
  //         [name]: value,
  //       });
  //     }
  //   }
  // };

  const onClickHandle = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      phoneNumber: /^[0-9]*$/,
      currentKey: /^[0-9]*$/,
      newKey: /^[0-9]*$/,
      confirmKey: /^[0-9]*$/,
    };

    if (validationRules[name]) {
      // Only update the state if the value is empty or passes the regex test
      if (validationRules[name].test(value) || value === "") {
        setUserData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }

    // Custom validation: Check if confirmKey matches newKey
    if (name === "confirmKey" || name === "newKey") {
      if (name === "confirmKey" && value !== userData.newKey) {
        simpleValidator.current.message(
          "confirmKey",
          value,
          "The confirm secret key should match the new secret key."
        );
      } else {
        // Clear the custom error message when keys match
        simpleValidator.current.hideMessageFor("confirmKey");
      }

      // Trigger a re-render to show the validation message
      forceUpdate(1);
    }
  };
  const loginPagePath = "/login/#";
  const changePassword = async () => {
    if (simpleValidator.current.allValid()) {
      const changeKey = {
        lpin: userData.currentKey,
        new_lpin: userData.newKey,
      };

      await axiosInstance
        .post("Api/pin_change", changeKey)
        .then((res) => {
          console.log(res.data, "res.data");
          localStorage.setItem("sessionUser", "");
          localStorage.setItem("authUser", "");
          toast.success("Secret Key changed successfully, Kindly re-login");
          setTimeout(() => {
            history.push(loginPagePath);
          }, 2000);
          return res.data;
        })
        .catch((error) => Promise.reject(error));
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const profileDetails = (
    <div className="hover:rounded-md hover:mr-[-3px] hover:bg-black-200 flex justify-between w-[140px] cursor-pointer">
      <div className="text-start mt-1">
        {/* <Link
          to={{
            pathname: "/profile",
            state: { row: "", data: "login" },
          }}
        > */}
        <Link
          to={{
            pathname: "/my-account",
          }}
        >
          <p
            className="flex text-[14px] font-semibold"
            style={{
              margin: "2px 0px",
            }}
          >
            <UserOutlined className="mr-2" /> Profile
          </p>
        </Link>

        {/* </Link> */}

        <Divider className="w-[112%] mt-[8px] mb-[8px] ml-[-10px]" />
        <p
          className="flex text-[14px] font-semibold hover:text-blue-300"
          style={{
            margin: "2px 0px",
            whiteSpace: "nowrap",
          }}
          onClick={() => setModal(true)}
        >
          <FaKey
            fontSize="small"
            style={{
              marginTop: "4px",
            }}
            className="mr-2"
          />
          Change Secret Key
        </p>

        <Divider className="w-[112%] mt-[8px] mb-[8px] ml-[-10px]" />
        <p
          className="flex text-[14px] font-semibold"
          style={{
            margin: "2px 0px",
          }}
        >
          {/* <Link
            to={{
              pathname: "/login",
              state: { row: "", data: "login" },
            }}
          > */}
          <a
            href={loginPagePath}
            onClick={() => {
              localStorage.setItem("sessionUser", "");
              localStorage.setItem("mobileNo", "");
              localStorage.setItem("reward", "");
              localStorage.setItem("rewardResponse", "");
            }}
          >
            <LogoutOutlined className="mr-2" /> Logout
          </a>
          {/* </Link> */}
        </p>
      </div>
    </div>
  );

  console.log(props, "props");
  const [selectedMenu, setSelectedMenu] = useState("");
  console.log(props.location, "location");
  const history = useHistory();

  const userDetails = localStorage.getItem("sessionUser");

  console.log(userDetails, "userDetails");

  const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
  console.log(userInfo, "userInfo");

  const userInfoDetails =
    !isEmpty(userInfo) &&
    userInfo.data &&
    userInfo.data.data &&
    userInfo.data.data.user
      ? userInfo.data.data.user
      : "";

  const avatarName =
    !isEmpty(userInfoDetails) && userInfoDetails.first_name
      ? userInfoDetails.first_name.slice(0, 1)
      : "";

  return (
    <React.Fragment>
      <Layout
        style={
          {
            // padding: "6px",
          }
        }
      >
        <Header
          className="layout-header"
          style={{
            position: "fixed",
            top: "1px",
            width: " 100%",
            padding: "30px 0px",
          }}
        >
          <div
            className="layout-header-image"
            onClick={() => {
              history.push("/dashboard");
            }}
          >
            <Image src={Logo1} preview={false} height={50} width={100} />
          </div>
          <div className="layout-header-menu">
            {items.map((data, index) => {
              console.log(data, "menu");
              return (
                <div
                  key={index}
                  className={
                    selectedMenu === data.key ||
                    props.location.pathname === data.label.props.to.pathname
                      ? "flex border-b-2 text-[#3498db] border-blue-400 pr-4 pl-4 cursor-pointer"
                      : "flex pl-4 pr-4 hover:text-blue-400 cursor-pointer"
                  }
                  onClick={() => setSelectedMenu(data.key)}
                >
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-poppins h-[100%] layout-header-menu-label font-semibold"
                  >
                    {data.label}
                  </h1>
                </div>
              );
            })}
          </div>
          {/* <Menu
            defaultSelectedKeys={"myAccount"}
            theme="light"
            mode="horizontal"
            triggerSubMenuAction="hover"
            className="font-Poppins text-start h-[60px] text-[14px] font-semibold"
            items={items}
          /> */}
          <Popover
            trigger={"click"}
            placement="bottom"
            content={profileDetails}
            className="layout-header-profile mr-6 border border-gray-100 rounded-md"
          >
            <div className="flex justify-between pl-2 pr-2">
              <div
                className="flex"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                <Avatar
                  style={{
                    backgroundColor: "#8400ff",
                    marginTop: "8px",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                  size={"small"}
                >
                  {!isEmpty(avatarName) ? avatarName : "A"}
                </Avatar>{" "}
                <div className="mt-[-20px]">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                    }}
                    className="layout-header-profile-name font-semibold"
                  >
                    {!isEmpty(userInfoDetails)
                      ? userInfoDetails.first_name
                      : ""}
                  </h1>
                  <p
                    className="layout-profile-points-head align-center"
                    style={{
                      position: "relative",
                      padding: "1px 2px",
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      borderRadius: "4px",
                    }}
                  >
                    <p className="layout-profile-points">0 pts</p>
                  </p>
                </div>
              </div>
              <DownOutlined className="cursor-pointer pl-2 pr-2" />
            </div>
          </Popover>

          {/* // Modal // */}

          <Modal
            open={modal}
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
            }}
            onCancel={() => {
              setModal(false);
            }}
            maskClosable={false}
            centered
            footer={[
              <Button key="back" onClick={() => setModal(false)}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => changePassword()}
              >
                Change
              </Button>,
            ]}
          >
            <Header
              style={{
                backgroundColor: "white",
              }}
            >
              <Typography.Title
                level={4}
                style={{
                  margin: 0,
                  marginLeft: "-35px",
                }}
              >
                Reset Secret Key
              </Typography.Title>
            </Header>

            <Divider
              className="w-[110%]"
              style={{
                marginLeft: "-20px",
                marginTop: "-15px",
              }}
            />

            <Content
              style={{
                marginTop: "-10px",
                padding: "0px 16px 3px 16px", // Add padding to the content area
              }}
            >
              {/* <Form.Item className="custom-form-item" style={{ marginBottom: '16px' }}>
                <Typography className="mb-1">Phone Number</Typography>
                <Input
                  placeholder=" Enter phone no"
                  size="small"
                  name="phoneNumber"
                  prefix={<MobileTwoTone />}
                  value={userData.phoneNumber}
                  onChange={(e) => onClickHandle(e)}
                  maxLength={10}
                  style={{
                    height: "35px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "Registered mobile no",
                    userData.phoneNumber,
                    "required"
                  )}
                </p>
              </Form.Item> */}
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "16px" }}
              >
                <Typography
                  style={{
                    display: "flex",
                  }}
                >
                  {" "}
                  Current Secret Key {""}
                  <span
                    style={{
                      color: "red",
                      marginLeft: "2px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Input.Password
                  placeholder=" Enter current secret key"
                  size="small"
                  name="currentKey"
                  maxLength={4}
                  value={userData.currentKey}
                  onChange={(e) => onClickHandle(e)}
                  style={{
                    height: "35px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "current secret key",
                    userData.currentKey,
                    "required"
                  )}
                </p>
              </Form.Item>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "16px" }}
              >
                <Typography
                  style={{
                    display: "flex",
                  }}
                >
                  New Secret Key {""}
                  <span
                    style={{
                      color: "red",
                      marginLeft: "2px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Input.Password
                  placeholder=" Enter new secret key"
                  size="small"
                  name="newKey"
                  maxLength={4}
                  value={userData.newKey}
                  onChange={(e) => onClickHandle(e)}
                  style={{
                    height: "35px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "new key",
                    userData.newKey,
                    "required"
                  )}
                </p>
              </Form.Item>
              <Form.Item
                className="custom-form-item"
                style={{ marginBottom: "16px" }}
              >
                <Typography
                  style={{
                    display: "flex",
                  }}
                >
                  Confirm Secret Key {""}
                  <span
                    style={{
                      color: "red",
                      marginLeft: "2px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <Input.Password
                  placeholder="confirm secret key"
                  size="small"
                  name="confirmKey"
                  maxLength={4}
                  value={userData.confirmKey}
                  onChange={(e) => onClickHandle(e)}
                  style={{
                    height: "35px",
                  }}
                />
                <p className="text-start text-[red] mt-1 text[11px]">
                  {simpleValidator.current.message(
                    "confirm secret key",
                    userData.confirmKey,
                    "required"
                  )}
                  {userData.confirmKey &&
                    userData.confirmKey !== userData.newKey &&
                    "The confirm secret key should match the new secret key."}
                </p>
              </Form.Item>
            </Content>
          </Modal>
        </Header>

        <Content className="content-card mt-[50px]">
          <div
            style={{
              // padding: "8px 2px",
              textAlign: "start",
            }}
          >
            {props.children}
          </div>
        </Content>
        <Footer className="footer-main">
          <div
            className="footer-social-link"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            <Typography
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
              className="font-semibold text-[#ffffff] text-[14px] mr-3"
            >
              Reach Us:
            </Typography>
            <div className="flex">
              <a
                href="https://www.instagram.com/planmitrip/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined className="rounded-full bg-[#ffffff] p-1 mr-2" />
              </a>
              <a
                href="https://www.facebook.com/planmitrip.india"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookOutlined className="rounded-full bg-[#ffffff] p-1 mr-2" />
              </a>
              {/* <a href="https://twitter.com/planmitrip" target="_blank" rel="noopener noreferrer">
                <BsTwitterX className="rounded-full bg-[#ffffff] p-1 mr-2" size={"22"} />
              </a> */}
              <a
                href="https://www.youtube.com/channel/UCKXctel46iL_KLYwsltC1Sg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeFilled className="rounded-full bg-[#ffffff] p-1 mr-2" />
              </a>
              {/* <a href="https://www.linkedin.com/company/planmitrip" target="_blank" rel="noopener noreferrer">
                <LinkedinFilled className="rounded-full bg-[#ffffff] p-1" />
              </a> */}
            </div>
          </div>
          <div className="footer-content uppercase text-[#ffffff] text-[12px]">
            <h1 className="footer-content-link">
              <Link
                to={{
                  pathname: "/about-program",
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {" "}
                About the program{" "}
              </Link>
            </h1>
            <h1 className="footer-content-link">
              <Link
                to={{
                  pathname: "/contact-us",
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Contact us
              </Link>
            </h1>
            <h1 className="footer-content-link">
              <Link
                to={{
                  pathname: "/faq",
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                FAQ
              </Link>
            </h1>
            <h1 className="footer-content-terms-link">
              <Link
                to={{
                  pathname: "/terms-conditions",
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                T&C
              </Link>
            </h1>
          </div>
        </Footer>
      </Layout>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          fontSize: "12px",
        }}
        theme="colored"
      />
    </React.Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutMain);
